import { useEffect } from 'react';

type ShortcutMap = Record<string, () => void>;

export function useKeyboardShortcuts(shortcuts: ShortcutMap) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!event || !event.key) return;

      // Don't trigger plain-key shortcuts (e.g. Escape) while the user is
      // typing in an input, textarea, or editable element. Ctrl/Alt combos
      // (Ctrl+O, Ctrl+F, ...) still work everywhere.
      const target = event.target as HTMLElement | null;
      const isTypingContext =
        !!target &&
        (target.tagName === 'INPUT' ||
          target.tagName === 'TEXTAREA' ||
          target.tagName === 'SELECT' ||
          target.isContentEditable);
      if (isTypingContext && !event.ctrlKey && !event.metaKey && !event.altKey) {
        return;
      }

      const key = event.key.toLowerCase();
      const ctrlKey = event.ctrlKey || event.metaKey;
      const altKey = event.altKey;
      const shiftKey = event.shiftKey;

      // Build shortcut string
      const shortcutParts = [];
      if (ctrlKey) shortcutParts.push('ctrl');
      if (altKey) shortcutParts.push('alt');
      if (shiftKey) shortcutParts.push('shift');
      shortcutParts.push(key);

      const shortcutString = shortcutParts.join('+');
      
      if (shortcuts[shortcutString]) {
        event.preventDefault();
        shortcuts[shortcutString]();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [shortcuts]);
}

